import {SxType} from "@baseTypes/sx/sxTypes";
import {FRAME_BORDER_SYNC, RADIUS_SYNC} from "@containers/singleVoyage/voyageTemplates/sync/theme";

const CHANGED = '#E07A10'

export const sx: SxType = {
	root: {
		minWidth: 0,
		gap: '10px',
	},
	header: {
		flexDirection: 'row',
		alignItems: 'baseline',
		flexWrap: 'wrap',
		gap: '2px 12px',
	},
	title: {
		fontSize: '14px',
		fontWeight: 600,
	},
	plate: {
		fontSize: '12px',
		color: 'text.secondary',
	},
	timeNew: {
		fontSize: '12px',
		fontWeight: 600,
	},
	timeOld: {
		fontWeight: 400,
		color: 'text.secondary',
		textDecoration: 'line-through',
	},
	// grows with the window, so the fullscreen modal gets a proportionally bigger map
	map: {
		flexShrink: 0,
		height: 'clamp(260px, 42vh, 640px)',
		borderRadius: RADIUS_SYNC,
		overflow: 'hidden',
		border: FRAME_BORDER_SYNC,
	},
	sectionLabel: {
		fontSize: '11px',
		fontWeight: 600,
		color: 'text.secondary',
		textTransform: 'uppercase',
		letterSpacing: '0.04em',
	},
	diverged: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		gap: '8px',
		p: '6px 10px',
		borderRadius: RADIUS_SYNC,
		border: '1px solid rgba(224, 122, 16, 0.5)',
		bgcolor: 'rgba(224, 122, 16, 0.08)',
	},
	divergedIcon: {
		fontSize: '18px',
		color: CHANGED,
		mt: '1px',
	},
	divergedText: {
		fontSize: '12px',
	},
}
